import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { USER_ROLE_PARTNER, USER_ROLE_ADMIN } from 'common/userRoles';

import allowedRoles from 'client/helpers/allowedRoles';

import branch from 'client/core/branch';

@allowedRoles({
  roles: [USER_ROLE_ADMIN, USER_ROLE_PARTNER],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@branch({
  currentPartner: ['partners', 'currentPartner'],
})
class PartnerOverviewRedirectPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Partner Overview | Sunroom Rentals',
  });

  static propTypes = {
    currentPartner: PropTypes.object,
  };

  render() {
    const { currentPartner } = this.props;

    if (currentPartner) {
      return <Redirect to={`/partner/${currentPartner.slug}`} />;
    }
    return <Redirect to="/feed" />;
  }
}

PartnerOverviewRedirectPage.displayName = 'PartnerOverviewRedirectPage';

export default PartnerOverviewRedirectPage;
